import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'mwp-manage-review-sass',
    templateUrl: './review-sass.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReviewSassComponent implements OnInit {

    constructor(
    ) {
    }

    ngOnInit(): void {
    }
}